import PresetsTool from './PresetsTool';
import './PresetsTool.scss';

export default PresetsTool;
